var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormAttribute", {
                attrs: {
                  data: _vm.eventAttributeKey,
                  loading: _vm.isFormLoading,
                  isNew: !_vm.name,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formAttributeSubmit,
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-attributes" })
                  },
                  "delete-attr": _vm.deleteAttribute,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmEventRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }